<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('customers')">Clienti</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.first_name }} {{ form.last_name }}
    </h1>
    <trashed-message v-if="customer.deleted_at" class="mb-6" @restore="restore">
      Il cliente è stato cancellato
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2"
            label="Cognome" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nome" />
          <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-8 w-full lg:w-1/2" label="Città" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2"
            label="Telefono" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!customer.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
            @click="destroy">Cancella Cliente</button>
          <button type="button" class="btn-indigo ml-auto" @click="resetPassword">
            Resetta Password
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Aggiorna
            Cliente</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.first_name} ${this.form.last_name}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    customer: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: this.customer.first_name,
        last_name: this.customer.last_name,
        city: this.customer.city,
        email: this.customer.email,
        phone: this.customer.phone,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('customers.update', this.customer.id))
    },
    resetPassword() {
      if (confirm('Sei sicuro di voler resettare la password del cliente?')) {
        this.$inertia.post(this.route('customers.resetPassword', this.customer.id))
          .then(() => {
            alert('Password resettata con successo.');
          });
      }
    },
    destroy() {
      if (confirm('Confermi la cancellazione del cliente?')) {
        this.$inertia.delete(this.route('customers.destroy', this.customer.id))
      }
    },
    restore() {
      if (confirm('Vuoi ripristinare il cliente?')) {
        this.$inertia.put(this.route('customers.restore', this.customer.id))
      }
    },
  },
}
</script>
